"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileMdReducer = exports.mobileReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
exports.mobileReducer = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case typesafe_actions_1.getType(GlobalAction_1.default.setIsMobile):
            return action.payload;
    }
    return state;
};
exports.mobileMdReducer = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case typesafe_actions_1.getType(GlobalAction_1.default.setIsMobileMd):
            return action.payload;
    }
    return state;
};
